__turbopack_context__.v({
  "chevron": "product-accordion-module__dulNjG__chevron",
  "item": "product-accordion-module__dulNjG__item",
  "panel": "product-accordion-module__dulNjG__panel",
  "panelInner": "product-accordion-module__dulNjG__panelInner",
  "productAccordion": "product-accordion-module__dulNjG__productAccordion",
  "trigger": "product-accordion-module__dulNjG__trigger",
});
